import { useQuery } from '@tanstack/react-query';
import { ADDITIONAL_DOCUMENTS_KEY } from '../../utils/constants/queryKeys';
import { getAdditionalDocuments } from '../services/document-api/Documents';

export const useGetAdditionalDocuments = (caseId: number) => {
  return useQuery({
    queryKey: [ADDITIONAL_DOCUMENTS_KEY, caseId],
    queryFn: () => getAdditionalDocuments(caseId),
    retry: false,
    enabled: !!caseId,
  });
};
